export const UI_VISIBILITY_ROLES: { id: string; label: string }[] = [
  { id: 'author', label: 'Standard' },
  { id: 'editor', label: 'Advanced' },
];
